<div class="loader-container">
  <mat-spinner *ngIf="!hideSpinner" [ngStyle]="{left: leftPosition ?? '50%'}"></mat-spinner>
</div>